import {Box} from "@mui/system";
import BasicLink from "../../../../v2/common/BasicLink";
import {buildLoginLink} from "./SignupUtils";

export default function GetStartedDescription() {
    const loginLink = buildLoginLink();

    return(
        <Box>
            <Box component="p" sx={styles.descParagraphHeader}>
                Hi! Welcome to{' '}
                <Box component="span" sx={{display: { xs: 'none', sm: 'none', md: 'inline', lg: 'inline' }}}>
                    <br />
                </Box>
                Remarkable AI. Let's get your account set up.
            </Box>
            <Box component="p" sx={styles.loginText}>
                Already have an account? <BasicLink label={`Log in.`} link={loginLink} sx={styles.link} />
            </Box>
        </Box>
    )
}

const styles = {
    descParagraphHeader: {
        color: '#0C2728',
        fontSize: { xs: '40px', sm: '40px', md: '60px', lg: '60px' },
        lineHeight: { xs: '48px', sm: '48px', md: '66px', lg: '66px' },
        fontFamily: 'IvyPrestoHeadlineRegular'
    },
    descParagraphBody: {
        color: '#0C2728',
        fontSize: '24px',
        lineHeight: '33.6px',
        fontFamily: 'FustatRegular'
    },
    loginText: {
        color: '#0C2728',
        mt: { xs: '40px', sm: '40px', md: '60px', lg: '60px' },
        fontSize: '18px',
        lineHeight: '18px',
        fontFamily: 'FustatRegular'
    },
    link: {
        fontFamily: 'FustatRegular',
        fontSize: '18px'
    }
};